<template>
  <el-container class="modeltwo">
    <el-main>
      <div class="topContainer">
        <div class="container">
          <div style="margin:10px 0px">
            <search-andselect></search-andselect>
          </div>
          <div class="mainTop">
            <classify-nav :label="label"></classify-nav>
            <div class="slideShow">
              <div class="left">
                <el-carousel trigger="click" height="442px">
                  <el-carousel-item v-for="(item,index) in banner.list" :key="index">
                    <a class="bannerLink" :href="item.link_url">
                      <img :src="item.photo1" alt />
                      <p v-text="item.title"></p>
                    </a>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="right">
                <div class="top" v-if="!login_success">
                  <el-row>
                    <el-form label-position="left">
                      <el-form-item label="账号">
                        <el-input v-model="userName" placeholder="请输入邮箱"></el-input>
                        <span class="accountIcon"></span>
                      </el-form-item>
                      <el-form-item label="密码">
                        <el-input v-model="userPassword" type="password" placeholder="请输入密码"></el-input>
                        <span class="passwordIcon"></span>
                      </el-form-item>
                    </el-form>
                  </el-row>
                  <el-row type="flex" justify="end">
                    <el-button @click="toLogin">登录</el-button>
                  </el-row>
                  <el-row type="flex" justify="center" class="inText">
                    <router-link class="forgot" to="./resetpass">忘记密码</router-link>
                    <i>|</i>
                    <router-link class="sogin" to="/register">注册</router-link>
                  </el-row>
                </div>
                <div class="bottom" :style="changeHeight">
                  <el-row>
                    <el-row type="flex" justify="space-between">
                      <h3>系统通知</h3>
                      <a @click="showMore" style="cursor:pointer">查看更多</a>
                      <el-dialog
                        title="通知"
                        class="showmoredia"
                        :visible.sync="isshowMore"
                        width="30%"
                        height="200px"
                      >
                        <el-scrollbar>
                          <a
                            href="#"
                            v-for="(item, index) in message.list"
                            :key="index"
                            @click="showDetail(item)"
                          >
                            <p class="dialogP">
                              <span style="margin-right:20px">{{item.title}}</span>
                              <i>{{item.create_time.slice(0,10)}}</i>
                            </p>
                          </a>
                        </el-scrollbar>
                        <span slot="footer" class="dialog-footer">
                          <el-button size="mini" type="primary" @click="isshowMore = false">关 闭</el-button>
                        </span>
                      </el-dialog>
                    </el-row>
                    <el-row>
                      <a
                        href="#"
                        v-for="(item, index) in message.list"
                        v-if="index<changeindex"
                        :key="index"
                        @click="showDetail(item)"
                      >
                        <p>
                          <span class="noticeText">{{item.title}}</span>
                          <i>{{item.create_time.slice(0,10)}}</i>
                        </p>
                      </a>
                      <el-dialog :title="detailObj.title" :visible.sync="dialogVisible" width="30%">
                        <p v-for="(item,index) in detailObj.body" :key="index">{{item}}</p>
                        <span slot="footer" class="dialog-footer">
                          <el-button size="mini" type="primary" @click="dialogVisible = false">关 闭</el-button>
                        </span>
                      </el-dialog>
                    </el-row>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="mainBottom">
          <hot-topic :hot="hot"></hot-topic>
        </div>
      </div>
    </el-main>
    <!-- <el-footer v-if="hidefooter" height="316px"> -->
    <el-footer
      v-if="hidefooter  && !showPeople"
      :style="{'height':  (this.webID == '111142' ? '120px' : '316px')}"
    >
      <help-footer v-if="this.webID == '111142'"></help-footer>
      <home-footer v-else></home-footer>
    </el-footer>
  </el-container>
</template>

<script>
import helpFooter from "../components/helpFooter.vue"; //底部
import searchAndselect from "../components/searchAndselect.vue";
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeHeader from "../components/homeHeader.vue"; //底部
import homeFooter from "../components/homeFooter.vue"; //底部
import peopleFooter from "../components/peopleFooter.vue"; //底部
import classifyNav from "../components/classifyNav.vue"; //全部分类
import hotTopic from "../components/hotTopic.vue"; //热门专题
import adsearch from "../components/adSearch.vue"; //顶部广告
import { mapGetters, mapActions } from "vuex";
import {
  getModuleInfo,
  userLogin,
  getUserInfo,
  signOut,
  newtitle,
  newtitle1,
  getResource,
  getCategoryNode
} from "./../services/api.js";

export default {
  name: "modelTwo",
  data() {
    return {
      //header
      isshowMore: false,
      dialogVisible: false,
      detailObj: {},
      opacity: "0.68",
      select: "0",
      searchText: "",
      //登录信息
      userName: "",
      userPassword: "",
      islogin: true,
      changeHeight: null,
      positionRight: null,
      //mainbottom
      activeIndex: "1",
      activeIndex2: "1",
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      //通知栏条数
      changeindex: 4,
      label: {
        id: "",
        list: []
      },
      banner: {
        id: "",
        list: [{ photo1: "" }]
      },
      hot: {
        id: "",
        list: []
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      message: {
        id: "",
        list: []
      },
      homeColor: {
        id: "",
        list: []
      }
    };
  },
  components: {
    homeHeader,
    homeFooter,
    classifyNav,
    hotTopic,
    adsearch,
    homeFooterAd,
    searchAndselect,
    helpFooter,
    peopleFooter
  },
  created() {
    this.setLoginSign(true);
    if (this.$route.query.text) {
      this.select = this.$route.query.type;
      this.searchText = decodeURI(this.$route.query.text);
    }
    if (sessionStorage.getItem("user")) {
      this.islogin = false;
      this.changeindex = 9;
      this.changeHeight = { height: "100%" };
      this.positionRight = { position: "static" };
    }
  },
  computed: {
    userInfo() {
      return sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
    },
    ...mapGetters([
      "webModels",
      "modelsInfo",
      "curModelInfo",
      "webID",
      "hidefooter",
      "login_success",
      "showPeople"
    ]),
    channel_id() {
      return this.curModelInfo.id;
      // return this.modelsInfo.filter(item => item.tpl_id == 1)[0].id;
    }
  },
  watch: {
    login_success(val) {
      if (val) {
        this.changeHeight = { height: "100%" };
      } else {
        this.changeHeight = null;
      }
    },
    channel_id() {
      this.getModuleInfo();
    }
  },
  mounted() {
    this.getModuleInfo();
  },
  methods: {
    ...mapActions(["setLoginSign"]),
    showMore() {
      this.isshowMore = true;
    },
    showDetail(item) {
      this.detailObj = {
        title: item.title,
        body: item.body.split("。")
      };
      this.dialogVisible = true;
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    },
    //登录
    toLogin() {
      let data = {
        user_name: this.userName,
        password: this.userPassword
      };
      userLogin(data).then(res => {
        if (res.status_code == 1) {
          sessionStorage.setItem("token", res.data.token);
          let option = {
            headers: {
              Authorization: "Bearer " + res.data.token
            }
          };
          getUserInfo(option).then(res => {
            if (res.status_code == 1) {
              sessionStorage.setItem("user", JSON.stringify(res.data));
              this.$message.success("登录成功");
              this.islogin = false;
              this.changeindex = 9;
              this.changeHeight = { height: "100%" };
              this.positionRight = { position: "static" };

              this.setLoginSign(true);
            } else {
              this.$message.error("登录出错，请重试");
            }
          });
          // this.$router.push({path:'/'})
        } else {
          this.$message.error("请填写用户名和密码");
        }
      });
    },
    //登出
    signOut() {
      signOut().then(res => {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        if (this.$route.fullPath == "/") {
          location.reload();
          this.$message.success("退出成功");
        } else {
          this.$router.push({ path: "/" });
        }
      });
    },
    toPersonal() {
      this.$router.push({ path: "/personal" });
    },
    getSpecialShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["800x500"]) {
          return item.custom_index_image["800x500"];
        }
      }
      return item.index_image;
    },
    getSpecialShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["800x500"]) {
          return item.group_custom_index_image["800x500"];
        }
      }
      return item.group_index_image;
    },
    getCarouselShowImgUrl_Category(item) {
      if (item.custom_index_image) {
        if (item.custom_index_image["1200x950"]) {
          return item.custom_index_image["1200x950"];
        }
      }
      return item.index_image;
    },
    getCarouselShowImgUrl(item) {
      if (item.group_custom_index_image) {
        if (item.group_custom_index_image["1200x950"]) {
          return item.group_custom_index_image["1200x950"];
        }
      }
      return item.group_index_image;
    },
    async getHotsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        console.log(resul);
        return {
          photo1: resul.data
            ? this.getSpecialShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },
    async getGroupsDataByCategoryChangeV(item) {
      var obj = {
        review_state: 1 + "",
        search_type: 2 + "",
        // online_state: 1 + "",
        customer_id: this.webid,
        group_id: item.body9
      };
      if (item.body10 == "1") {
        let resul = await getResource(obj, 2);
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl(resul.data.data[0])
            : "",
          link_url: `/search?isEnglish=false&type=1&text=&group_id=${item.body9}`,
          title: resul.data ? resul.data.data[0].group_title : ""
        };
      } else if (item.body10 == "2") {
        let resul = await getCategoryNode({
          customer_id: this.webid,
          category_id: item.body9
        });
        return {
          photo1: resul.data
            ? this.getCarouselShowImgUrl_Category(resul.data[0])
            : "",
          link_url: `/intopic?category=${item.body9}&text=${
            resul.data ? resul.data[0].cname : ""
          }&bigimg=${resul.data ? resul.data[0].index_image : ""}`,
          title: resul.data ? resul.data[0].cname : ""
        };
      } else if (item.body10 == "3") {
        return {
          photo1: item.promotion_cover,
          link_url: `/spread?promotion=${item.promotion_pic}`,
          title: "推广页"
        };
      }
    },

    getModuleInfo() {
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var label = this.webModels.module_data.find(item => {
            if (item.title == "标签") return item;
          });
          var banner = this.webModels.module_data.find(item => {
            if (item.title == "A轮播图") return item;
          });
          var hot = this.webModels.module_data.find(item => {
            if (item.title == "A热门专题") return item;
          });
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var message = this.webModels.module_data.find(item => {
            if (item.title == "系统通知") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            channel_id: this.channel_id
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = label.id;

          let totallist = [];

          //登录前和登录后参数
          var loginToken = sessionStorage.getItem("token");
          if (loginToken) {
            var paramSelect = {
              customer_id: this.webID,
              permission: 1
            };
          } else {
            var paramSelect = {
              customer_id: this.webID
            };
          }

          newtitle({
            params: paramSelect
          }).then(res => {
            if (res) {
              if (res.status_code == 1) {
                var lis = res.data.list.filter(item => {
                  return item.level == 1 && item.active == 1;
                });
                lis.forEach(item => {
                  totallist.push({
                    id: item.id,
                    cname: item.cname,
                    type: item.type
                  });
                });
                newtitle1({
                  params: {
                    customer_id: this.webID
                  }
                }).then(res => {
                  if (res) {
                    if (res.status_code == 1) {
                      var lis = res.data.list.filter(item => {
                        return item.level == 1 && item.active == 1;
                      });
                      lis.forEach(item => {
                        totallist.push({
                          id: item.id,
                          cname: item.cname,
                          type: item.type
                        });
                      });
                      this.label = {
                        id: 1,
                        list: totallist
                      };
                    }
                  }
                });
              }
            }
          });

          data.module_id = banner.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: banner.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.banner = {
                id: banner.id,
                list: res.data.list
              };
              for (let i = 0; i < this.banner.list.length; i++) {
                let resul = await this.getGroupsDataByCategoryChangeV(
                  this.banner.list[i]
                );
                this.banner.list[i].photo1 = resul.photo1;
                this.banner.list[i].link_url = resul.link_url;
                this.banner.list[i].title = resul.title;
                this.$set(this.banner.list, i, this.banner.list[i]);
              }
            }
          });
          data.module_id = hot.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: hot.rows_num
          }).then(async res => {
            if (res.status_code == 1) {
              this.hot = {
                id: this.hot.id,
                list: res.data.list
              };
              for (let i = 0; i < this.hot.list.length; i++) {
                let resul = await this.getHotsDataByCategoryChangeV(
                  this.hot.list[i]
                );
                this.hot.list[i].photo1 = resul.photo1;
                this.hot.list[i].link_url = resul.link_url;
                this.hot.list[i].title = resul.title;
                this.$set(this.hot.list, i, this.hot.list[i]);
              }
            }
          });
          data.module_id = message.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: message.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.message = {
                id: message.id,
                list: res.data.list
              };
            }
          });
          data.module_id = homeColor.id;
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              var bgColor = this.homeColor.list[0].body;
              if (bgColor) {
                bgColor = bgColor.slice(1, 7);
                bgColor = bgColor.split("");
                var oXColor = [];
                for (let i = 0; i < 3; i++) {
                  oXColor.unshift(
                    parseInt(bgColor[i * 2] + bgColor[i * 2 + 1], 16)
                  );
                }
                this.homeColor.list[0].body = "rgba(" + oXColor.join(",") + ")";
              }
            }
          });
        }
      }, 0);
    },
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          type: this.select,
          text: encodeURI(this.searchText)
        }
      });
    },
    changeModel(module) {
      this.$router.push({ path: "/" });
    },
    ...mapActions(["setCurModelInfo"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.modeltwo {
  .el-footer {
    padding: 0px;
  }
  .showmoredia {
    .el-dialog__body {
      height: 300px;
      overflow: auto;
    }
  }
  .el-main {
    .mainTop {
      .slideShow {
        .left {
          .el-carousel__indicators {
            left: auto;
            right: 0;
            height: 56px;
            display: flex;
            align-items: center;
            .el-carousel__indicator {
              .el-carousel__button {
                width: 10px;
                height: 10px;
                border-radius: 50%;
              }
            }
          }
          .el-carousel__item {
            .bannerLink {
              display: block;
              width: 100%;
              height: 100%;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              p {
                position: absolute;
                width: calc(100% - 23px);
                background-color: rgba(0, 0, 0, 0.5);
                left: 0;
                bottom: 0;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular;
                color: rgba(255, 255, 255, 1);
                line-height: 20px;
                padding: 18px 0px 18px 23px;
              }
            }
          }
        }
      }

      .top {
        .el-input {
          width: 302px;
          height: 40px;
        }
        .el-form-item__label {
          padding: 0 20px 0 0;
        }
      }
    }
  }
  .dialogP {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    border-bottom: 1px solid gray;
  }
}
</style>

<style lang="less" scoped>
.el-header {
  padding: 0px;
  .homeHeaderCon {
    width: 100%;
    height: 70px;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: auto;
    margin-left: auto;
    border-bottom: 1px solid #e7e7e7;
  }
  .homeHeader {
    margin: 0 auto;
    width: 100%;
    height: 70px;
    position: fixed;
    display: flex;
    z-index: 1000;
    .logo {
      height: 100%;
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 120px;
        max-height: 70px;
      }
    }
    .nav {
      width: 294px;
      margin-right: 36px;
      .nav-content {
        display: flex;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        line-height: 20px;
        padding-top: 24px;
        justify-content: space-around;
        li {
          a {
            color: #484848;
            font-size: 14px;
          }
        }
      }
    }
    .search {
      position: absolute;
      right: 30px;
      top: 0px;
      width: 427px;
      height: 40px;
      margin-top: 14px;
      display: flex;
      .el-select {
        padding-right: 0;
        width: 150px;
      }
      .el-button {
        background-color: #f05941;
        color: #fff;
        padding: 0px;
        height: 40px;
        width: 40px;
        font-size: 20px;
      }
    }
    .loginBtn {
      position: absolute;
      top: 14px;
      right: 30px;
      width: 98px;
      height: 40px;
      background: rgba(240, 89, 65, 1);
      border-radius: 3px;
      .btnContent {
        height: 20px;
        width: 70px;
        margin-top: 10px;
        margin-left: 14px;
        display: flex;
        justify-content: space-between;
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
    .userInfo {
      // position: absolute;
      // width: 300px;
      // height: 100%;
      // right: 30px;
      // display: flex;
      // align-items: center;
      // justify-content: flex-end;
      // span {
      //   font-size: 16px;
      //   line-height: 45px;
      //   cursor: pointer;
      //   vertical-align: middle;
      // }
      // .userHead {
      //   margin-left: 10px;
      //   display: inline-block;
      //   width: 45px;
      //   height: 45px;
      //   vertical-align: middle;
      //   cursor: pointer;
      //   img {
      //     width: 100%;
      //     height: 100%;
      //     border-radius: 50%;
      //   }
      // }
    }

    .homeHeaderTwo {
      width: 100%;
      height: 70px;
      position: fixed;
      display: flex;
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
        /*background-color: red;*/
      }
      .nav {
        width: 294px;
        margin-right: 36px;
        .nav-content {
          display: flex;
          height: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          line-height: 20px;
          padding-top: 24px;
          justify-content: space-between;
          li {
            a {
              color: #fff;
            }
          }
        }
      }
      .search {
        width: 427px;
        height: 40px;
        margin-top: 14px;
        display: flex;
        .el-select {
          padding-right: 0;
          width: 130px;
        }
        .el-button {
          background-color: #f05941;
          color: #fff;
          padding: 0px;
          height: 40px;
          width: 40px;
          font-size: 20px;
        }
      }
      .loginBtn {
        position: absolute;
        top: 14px;
        right: 20px;
        width: 98px;
        height: 40px;
        background: rgba(240, 89, 65, 1);
        border-radius: 3px;
        .btnContent {
          height: 20px;
          width: 70px;
          margin-top: 10px;
          margin-left: 14px;
          display: flex;
          justify-content: space-between;
          color: #ffffff;
          a {
            color: #ffffff;
          }
        }
      }
    }
  }
}

.el-main {
  overflow: hidden;
  padding: 0;
  .mainTop {
    width: 100%;
    height: 442px;
    background-color: #f7f7f7;
    // padding: 31px 0 33px 0;
    display: flex;
    .slideShow {
      width: 100px;
      height: 100%;
      flex: 1 1 auto;
      display: flex;
      .left {
        width: 560px;
        height: 100%;
        margin-right: 10px;
        position: relative;
        .el-carousel__indicators {
          left: auto;
          right: 0;
          height: 56px;
          display: flex;
          align-items: center;
          .el-carousel__indicator {
            .el-carousel__button {
              width: 10px;
              height: 10px;
              border-radius: 50%;
            }
          }
        }
        .el-carousel__item {
          .bannerLink {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            p {
              position: absolute;
              width: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              left: 0;
              bottom: 0;
              height: 56px;
              font-size: 14px;
              font-family: PingFangSC-Regular;
              color: rgba(255, 255, 255, 1);
              line-height: 56px;
              padding: 0px 0px 18px 23px;
            }
          }
        }
      }
      .right {
        width: 1px;
        height: 100%;
        flex: 1 1 auto;
        .top,
        .bottom {
          background-color: #ffffff;
          h3 {
            color: #444444;
          }
          a {
            color: #767676;
            p {
              color: #9e9e9e;
            }
          }
        }
        .top {
          width: 438px;
          height: 228px;
          box-sizing: border-box;
          margin-bottom: 10px;
          padding: 28px 44px 0px 44px;
          .inText {
            padding-left: 40px;
            i {
              color: #2789ee;
            }
            .forgot {
              font-size: 12px;
              color: #2789ee;
              margin-right: 8px;
            }
            .sogin {
              margin-left: 4px;
              font-size: 12px;
              color: #2789ee;
            }
          }
          .el-form-item {
            margin-bottom: 10px;
            .el-form-item__content {
              .accountIcon {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 18px;
                height: 18px;
                background: url("../../static/images/icon/account.png")
                  no-repeat center center;
              }
              .passwordIcon {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 18px;
                height: 18px;
                background: url("../../static/images/icon/password.png")
                  no-repeat center center;
                background-size: 14px 16px;
              }
            }
          }

          .el-button {
            width: 302px;
            height: 40px;
            background-color: #f05941;
            color: #fff;
            margin-bottom: 13px;
          }
        }
        .bottom {
          height: 202px;
          width: 438px;
          overflow: hidden;
          & > .el-row {
            height: 100%;
            display: flex;
            flex-direction: column;
            .el-row:nth-child(1) {
              box-sizing: border-box;
              padding: 8px 10px 8px 10px;
              background-color: rgba(241, 241, 241, 1);
              h3 {
                font-size: 14px;
              }
              a {
                font-size: 12px;
              }
            }
            .el-row:nth-child(2) {
              height: 100%;
              display: flex;
              flex-direction: column;
              p {
                .noticeText {
                  width: 260px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                background-color: #fff;
                height: 100%;
                box-sizing: border-box;
                padding: 13px 8px;
                border-bottom: 2px solid #f7f7f7;
                flex: 1 1 auto;
                display: flex;
                justify-content: space-between;
              }
            }
          }
        }
      }
    }
  }
  .mainBottom {
    width: 100%;
    height: 400px;
    box-sizing: border-box;
    padding: 30px 0px;
  }
}

.el-footer {
  background-color: #181a1a;
  position: relative;
}

.topContainer {
  width: 100%;
  background-color: #f7f7f7;
  .container {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.container {
  width: 1200px;
  margin: 0px auto;
}
</style>




// WEBPACK FOOTER //
// src/page/modelTwo.vue